import { createFileRoute } from "@tanstack/react-router";

import { ServerErrorPage } from "#/components/ErrorPage";

export const Route = createFileRoute("/500")({
  component: ServerErrorPage,
});
